import { deleteQueryParams, getNormalPromptQuery, getNormalUsername, getQueryParam, removeTenantDomainFromPath } from './helper';
/**
 * Parse authentication hints from the URL. Authentication hints includes username, tenantId, domain hint and prompt
 * @param href
 * @param param1
 */
export const authHintParser = (href, { usernameParams = ['upn', 'login_hint'], tenantIdParams = ['tid', 'tenant', 'tenantId'], domainParams = ['domain', 'domain_hint', 'whr'], promptParams = ['prompt'] } = {}) => {
    // get domain from url's pathname. This is assuming that the preferred domain to log user in fill follow
    // immediately after url origin (IE: myapplications.microsoft.com) so myapplications.microsoft.com/domain
    // is acceptable. myapplications.microsoft.com/somePath/domain) is not acceptable
    const { tenantDomain, url } = removeTenantDomainFromPath(new URL(href, window.location.origin));
    // get domain
    const domain = tenantDomain ?? getQueryParam(url, domainParams);
    // get tenantId
    const tenantId = getQueryParam(url, tenantIdParams);
    // get username
    const username = getNormalUsername(getQueryParam(url, usernameParams));
    // get prompt type
    const prompt = getNormalPromptQuery(getQueryParam(url, promptParams));
    if (!username && !domain && !tenantId && !prompt) {
        return null;
    }
    // This is essentially a cleaner version of the url with all the auth related hints removed
    // and should be used to replace the previous URL to maintain a cleaner browser history
    const cleanURL = deleteQueryParams(url, [...usernameParams, ...tenantIdParams, ...domainParams, ...promptParams]);
    return {
        authHints: { username, domain, tenantId, prompt },
        cleanUrl: cleanURL.href
    };
};
//# sourceMappingURL=authHintParser.js.map